<template>
  <div class="my-outbox" ref="outbox">
    <div class="my-inbox" ref="movebox">
      <div class="my-listbox" v-for="(item, index) in hall_sacrifice_list" :key="index">
        <div :key="index" class="mourn-pray-record">
          <div class="mourn-pray-record_item" :style="getColor()">
            <img class="avatar" :src="item.img" />
            <div class="info">
              <div class="name">{{ item.nicheng }}</div>
              <div class="goods-name">{{ item.content }}</div>
              <!-- {{ getGoodsName(item.goodsId) }} -->
            </div>
            <div class="pray-img">
              <!-- <img :src="getGoodsImg(item.goodsId)" /> -->
              <img
                v-if="$properties(item.sourceSubtype, 'value') == 'candle'"
                src="../../../assets/jnt/lazhu1.png"
                alt=""
              />
              <img
                v-if="$properties(item.sourceSubtype, 'value') == 'goods'"
                :src="item.targetPhoto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-marquee-top',
  props: ['hall_sacrifice_list', 'hallGoodsList', 'jntTemplateId'],
  data() {
    return {
      isShow: true,
    }
  },
  methods: {
    getColor() {
      let _css = 'background:rgba(255, 255, 255, 0.2);  color: rgb(255, 255, 255);'
      if (this.jntTemplateId == 2 || this.jntTemplateId == 3 || this.jntTemplateId == 5) {
        _css = 'background: rgba(0, 0, 0, 0.4); color: rgb(255, 255, 255);'
      }
      return _css
    },
    getGoodsName(id) {
      let _name = ''
      this.hallGoodsList.map(item => {
        if (item.id == id) {
          _name = item.proName
        }
      })
      return _name
    },
    getGoodsImg(id) {
      console.log(id)
      let _img = ''

      this.hallGoodsList.map(item => {
        if (item.id == id) {
          _img = item.firstPhoto
        }
      })
      return _img
    },
  },
  mounted: function() {
    let self = this
    setTimeout(() => {
      var moveTarget = self.$refs.movebox
      var outbox = self.$refs.outbox
      if (outbox.offsetHeight > moveTarget.offsetHeight / 2) {
        self.isShow = false
        return
      }
      var initTop = 0
      setInterval(function() {
        initTop++
        if (initTop >= moveTarget.offsetHeight / 2) {
          initTop = 0
        }
        moveTarget.style = 'transform: translateY(-' + initTop + 'px)'
      }, 30)
    }, 500)
  },
  watch: {
    // hall_sacrifice_list: {
    //   handler() {
    //     this.$router.go(0)
    //   },
    //   deep: true,
    // },
  },
}
</script>

<style>
.my-outbox {
  width: 85%;
  height: 14.08rem;
  margin: 0 auto;
  position: fixed;
  bottom: 7.88rem;
  z-index: 10;
  overflow: hidden;
  padding-top: 20px;
  padding-left: 15px;
}
.my-outbox .my-inbox {
}
.my-outbox .my-inbox .my-listbox {
  padding: 0.2rem 0;
  font-size: 0.9rem;
}
.my-title {
  color: #db7000;
  margin-bottom: 10px;
  clear: both;
  overflow: hidden;
}
.my-content {
  text-align: justify;
  word-break: break-all;
  font-size: 14px;
  color: #53565d;
}
.my-utel {
  font-size: 16px;
  margin-left: 20px;
}
.my-addr {
  font-size: 16px;
  float: right;
}
.mourn-pray-record {
  align-items: center;
  display: block;
}
.mourn-pray-record .mourn-pray-record_item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 24px;
  padding: 0 0.3rem;
  margin-bottom: 1.46rem;
  width: fit-content;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  line-height: 1.35rem;
}

.mourn-pray-record_item .avatar {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid #e4803c;
}

.mourn-pray-record_item .info {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  padding-left: 0.6rem;
  padding-top: 0.1rem;
}
.mourn-pray-record_item .info .name {
  color: #fff;
  font-size: 0.9rem;
}
.mourn-pray-record_item .info .goods-name {
  color: #f1a524;
  font-size: 0.9rem;
}
.mourn-pray-record_item .pray-img {
  width: 35px;
  position: relative;
  margin-left: 1.44rem;
  margin-right: 0.6rem;
}
.mourn-pray-record_item .pray-img img {
  width: 100%;
  position: absolute;
  top: -2.45rem;
}
</style>
